import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import LanguageContainer from './LanguageContainer';
import NotFound from './NotFound';

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/:country">
          <LanguageContainer />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
